/* tslint:disable */
/* eslint-disable */
/**
 * Swagger
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 * @interface Bpwallet
 */
export class Bpwallet {
    /**
     *
     * @type {string}
     * @memberof Bpwallet
     */
    _id: string;
    /**
     *
     * @type {string}
     * @memberof Bpwallet
     */
    namespace: string;
    /**
     *
     * @type {string}
     * @memberof Bpwallet
     */
    type: string;
    /**
     *
     * @type {string}
     * @memberof Bpwallet
     */
    merchantId: string;
    /**
     *
     * @type {string}
     * @memberof Bpwallet
     */
    secretKey: string;
    /**
     *
     * @type {string}
     * @memberof Bpwallet
     */
    apiKey: string;
    /**
     *
     * @type {string}
     * @memberof Bpwallet
     */
    username: string;
    /**
     *
     * @type {string}
     * @memberof Bpwallet
     */
    password: string;
    /**
     *
     * @type {boolean}
     * @memberof Bpwallet
     */
    sandbox: boolean;
    /**
     *
     * @type {boolean}
     * @memberof Bpwallet
     */
    autoApprove: boolean;
}
